import { graphql, useStaticQuery } from "gatsby";
import { LocationClass } from "gatsby-source-patstore";

const useGetLocation = () => {
    const data = useStaticQuery(graphql`
        query AllPatstoreLocation {
            allPatstoreLocation {
                edges {
                    node {
                        id
                        
            objectId
    categories
    label
    title
    createdAt
    text
    
                    }
                }
            }
        }
    
        `);


    const allLocation: LocationClass[] =
        data.allPatstoreLocation.edges.map(
            (edge: { node: LocationClass }) => edge.node
        ) || [];

    const findLocation: (id: string) => LocationClass | undefined = (id: string) => {
        const result = allLocation.find((item: LocationClass) => item.objectId === id);

        if (!result) {
            return undefined;
        }

        return result;
    };

    return {
        findLocation,
        locations: allLocation,
    };
}; 

export default useGetLocation;
